import * as React from 'react';
import { useMeasure } from '@epihub/web/src/hooks/useMeasure';
import { styled } from '../../theme/theme';
import { ChatViewMessageBoxAnimationContext } from './ChatViewMessageBoxAnimationContext';
import { KeyboardContext } from './KeyboardContext';
import { MessageList } from './MessageList';
import { ChatViewInput } from './ChatViewInput';

type Props = {
  //
};

export const Chat = ({}: Props) => {
  const { measurementRef, measurements } = useMeasure();
  const { chatListScroller } = React.useContext(ChatViewMessageBoxAnimationContext);
  const { keyboardOpen } = React.useContext(KeyboardContext);
  return (
    <Root>
      {!keyboardOpen && <Flexer ref={measurementRef} />}
      <Scroll
        height={measurements?.height ?? 0}
        ref={chatListScroller?.scrollableRefInternal}
        keyboardOpen={keyboardOpen}
      >
        <SubRoot>
          <MessageList />
        </SubRoot>
      </Scroll>
      <StyledChatViewInputContainer>
        <ChatViewInput />
      </StyledChatViewInputContainer>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

const Flexer = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
`;

const Scroll = styled.div<{ keyboardOpen: boolean; height: number }>`
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
  ${({ keyboardOpen, height }) => (keyboardOpen
  ? `
  `
  : `
    position: absolute;
    overflow: auto;
    flex-direction: column-reverse;
    min-height: ${height - 25}px;
    max-height: ${height - 25}px;
  `)};
`;

const SubRoot = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    padding-top: 180px; // Account for fixed header
    padding-bottom: 120px; // Account for fixed input area with quick responses
  }
`;

// Liquid Glass effect constants for mobile input area
const INPUT_BLUR_INTENSITY = 20;

const StyledChatViewInputContainer = styled.div`
  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2; // Below #spring (z-index: 3) so Lottie renders on top
    padding: 24px 5vw;
    padding-top: 32px;

    // Use pseudo-element for blur only (no background)
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
      backdrop-filter: blur(${INPUT_BLUR_INTENSITY}px);
      -webkit-backdrop-filter: blur(${INPUT_BLUR_INTENSITY}px);
      mask-image: linear-gradient(
        to top,
        black 0%,
        black 50%,
        transparent 100%
      );
      -webkit-mask-image: linear-gradient(
        to top,
        black 0%,
        black 50%,
        transparent 100%
      );
    }
  }
`;
